import { z } from "zod";
import { env } from "../../env";
import {
  parseServiceInput,
  parseServiceOutput,
  requestConfig,
} from "../../globals";
import { getAuth } from "../../utils";
import { type Wishlist, wishlist } from "../schemas/wishlist";

export const addAnonymousWishlistItemProps = z
  .object({
    wishlistToken: z.string(),
    wishlistId: z.string(),
    productId: z.string(),
    variantId: z.string().optional(),
  })
  .extend(requestConfig.shape);

export type AddAnonymousWishlistItemProps = z.infer<
  typeof addAnonymousWishlistItemProps
>;

export const addAnonymousWishlistItem = async (
  args: AddAnonymousWishlistItemProps,
): Promise<Wishlist> => {
  const {
    endpoint = env.ACCOUNT_SERVICE_URL,
    auth: Authorization = getAuth(),
    wishlistToken,
    wishlistId,
    productId,
    variantId,
  } = parseServiceInput(addAnonymousWishlistItemProps, args);

  const headers = new Headers({
    "Content-Type": "application/json",
    Authorization,
  });
  if (wishlistToken) {
    headers.append("x-wishlist-token", `Bearer ${wishlistToken}`);
  }

  const response = await fetch(`${endpoint}/v1/wishlist/anonymous`, {
    method: "POST",
    headers,
    body: JSON.stringify({ wishlistId, productId, variantId }),
  });

  return parseServiceOutput(response, wishlist, {
    code: "MALFORMED_WISHLIST",
    message: "Wishlist is malformed",
  });
};
